/**
 * passing undefined as ack makes socket treat it as an extra argument,
 * thus if it is not required, we just omit argument as a whole
 */
export var wrapAck = function wrapAck(ack) {
  return ack ? [ack] : [];
};